import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Icon } from 'coreOld/elements';
import { theme } from 'coreOld/themes';
import { isString } from 'coreOld/utils';

interface IProps {
  fullHeight?: boolean;
  overlay?: boolean;
  minHeight?: number | string;
}

type CenterProps = {
  fullHeight?: boolean;
  overlay?: boolean;
  minHeight?: number | string;
  children?: ReactNode;
};

export const Center = styled.div<CenterProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ fullHeight, theme }) =>
    fullHeight &&
    css`
      height: 100%;
      min-height: 100%;
      background-color: ${theme.palette.backgrounds.loading};
      opacity: 0.5;
    `};

  ${({ minHeight }) =>
    minHeight &&
    css`
      min-height: ${isString(minHeight) ? minHeight : `${minHeight}px`};
    `};

  ${({ overlay }) =>
    overlay &&
    css`
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      z-index: 2;
    `}
`;

type WrapperProps = { fullHeight?: boolean; children?: ReactNode };

export const Wrapper = styled.div<WrapperProps>`
  font-size: 2em;
  width: 40px;
  height: 40px;
  padding-bottom: 40px;

  ${({ fullHeight }) =>
    !fullHeight &&
    css`
      position: absolute;
      bottom: 0%;
      right: 50%;
    `};
`;

const Loader = ({ fullHeight = false, overlay = false, minHeight }: IProps) => {
  return (
    <Center fullHeight={fullHeight} overlay={overlay} minHeight={minHeight}>
      <Wrapper fullHeight={fullHeight}>
        <Icon
          name={Icon.SPINNER}
          style={{ fill: fullHeight && theme.palette.text.secondary }}
          rotate
        />
      </Wrapper>
    </Center>
  );
};

export default Loader;
